// VpnWarningPopup.vue
<template>
  <div v-if="showPopupModal" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-border-container">
        <button class="close-btn" @click="closeModal">X</button>
        <div class="modal-header">
          <h2>IMPORTANT</h2>
          <h2>ÖNEMLİ</h2>
          <h2>IMPORTANTE</h2>
        </div>
        <div class="modal-body">
          <h3>Are you using <span class="highlight">VPN</span>?</h3>
          <div class="content">
            <div class="item">
              <img src="/img/flags/tr.png" alt="Turkish Flag" class="flag">
              <p>VPN satın alımları şüpheli olarak sınıflandırılabilir ve başarısızlıkla sonuçlanabilir.
                Kullanıyorsanız, ödeme için fişini çekin ve gizliliğiniz için tekrar takın.</p>
            </div>
            <div class="item">
              <img src="/img/flags/gb.png" alt="UK Flag" class="flag">
              <p>VPN purchases may be classified as suspicious and may result in failure. If you're using one, unplug it
                for payment and then plug it back in for your privacy.</p>
            </div>
            <div class="item">
              <img src="/img/flags/it.png" alt="Italian Flag" class="flag">
              <p>Gli acquisti VPN potrebbero essere classificati come sospetti e potrebbero fallire. Se ne utilizzi uno,
                scollegalo per il pagamento e quindi ricollegalo per la tua privacy.</p>
            </div>
            <div class="item">
              <img src="/img/flags/es.png" alt="Spanish Flag" class="flag">
              <p>Las compras con VPN pueden ser calificadas como sospechosas y podrían resultar fallidas. Si estás
                usando uno, desconéctalo para el pago y luego vuelve a conectarlo para tu privacidad.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="logo"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VpnWarningPopup',
  props: {
    purchaseOptions: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      showPopupModal: false,
    }
  },
  mounted() {
    this.showPopupModal = this.purchaseOptions.length > 0 && this.purchaseOptions[0].show_vpn_popup;
  },
  methods: {
    closeModal() {
      this.showPopupModal = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables";
@import "../styles/classes";

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: var(--background_03);
  border-radius: 8px;
  padding: 12px;
  width: 80%;
  max-width: 600px;
  position: relative;
  color:black;
  height: 90%;
  overflow-y: auto; 
  overflow-x: hidden;
}

.modal-border-container{
  border: 3px solid var(--pallete_main_color);
  border-radius: 50px;
}

.close-btn {
  position: absolute;
  top: 25px;
  right: 30px;
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
}

.modal-header{
  margin-top: 40px;
}

.modal-header h2 {
  margin: 0;
  text-align: center;
  font-size: 1.7em;
}

.modal-body h3 {
  text-align: center;
  font-size: 1.7em;
  margin-bottom: 20px;
}

.highlight {
  color: var(--pallete_main_color);
}

.content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-right: 6%;
}

.item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
}

.flag {
  width: 40px;
  margin: 0 10%;
}

.modal-footer {
  text-align: center;
  margin-top: 20px;
  font-weight: bold;
}

.logo {
  height: 40px;
  background-image: var(--img-logo);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-bottom:40px;

  @media (max-width: 900px) {
    width: 100%;
  }
}
</style>
